import * as yup from 'yup';
import moment from 'moment';

export const addEditActionStepValidation = yup.object().shape({
  text: yup.string().required('Action step description is required'),

  dueDate: yup.string().test('dueDate', 'Please enter a valid due date', value => {
    if (!value) {
      return true;
    }
    const parsedDate = moment(value, 'MM/DD/YYYY', true);

    return parsedDate.isValid();
  }),
});
